export default {
  NotPostedVoucher: '#ff0000',
};
